import axios from "axios";
import { useEffect, useState } from "react";

function JobOpening() {
  const BASE_URL = process.env.REACT_APP_API_BASE;
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");

  // Fetch Job Data
  const fetchJobs = async (pageNumber = 1) => {
    try {
      setLoading(true);
      const res = await axios.get(`${BASE_URL}/getCareers`, {
        params: {
          per_page: 5,
          page: pageNumber,
          search: search.trim() || "",
        },
      });

      if (res.data?.status) {
        setJobs(res.data.data || []);
        setTotalPages(res.data.pagination?.last_page || 1);
      } else {
        setJobs([]);
      }
    } catch (error) {
      console.error("Error fetching jobs:", error);
    } finally {
      setLoading(false);
    }
  };

  // On Page Load & Page Change
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    fetchJobs(page);
  }, [page]);

  // Handle Search
  const handleSearch = (e) => {
    e.preventDefault();
    setPage(1);
    fetchJobs(1);
  };

  return (
    <section className="ser_v_araeea allpages joboptionspages">
      <div className="container">
        <div className="abt_pgs_areea">
          <h2>Discover Your Place at Weyfarin</h2>
          <div className="mg_bx_area">
            <img src="images/abou_us_bg.png" alt="about" />
          </div>

          <div className="filtter">
            <h2>All Jobs</h2>
            <p>{jobs.length} open roles</p>

            {/* Search Bar */}
            <form className="frm_al_fldss shedowss" onSubmit={handleSearch}>
              <input
                type="text"
                value={search}
                placeholder="Search by job title"
                onChange={(e) => setSearch(e.target.value)}
              />
              <button type="submit">
                <img alt="search" src="images/search.svg" />
              </button>
            </form>

            {/* Dropdown Filters */}
            <div className="slt_area_liststs">
              <div className="selectss">
                <select>
                  <option value="">Team</option>
                </select>
              </div>
              <div className="selectss">
                <select>
                  <option value="">Where you work</option>
                </select>
              </div>
              <div className="selectss">
                <select>
                  <option value="">Work Flexibility</option>
                </select>
              </div>
            </div>
          </div>

          {/* Job Listings */}
          <div className="list_filtters">
            <h3>
              Showing {(page - 1) * 5 + 1}-
              {(page - 1) * 5 + jobs.length} results out of total{" "}
              {5 * totalPages} open jobs
            </h3>

            {loading ? (
              <p>Loading jobs...</p>
            ) : jobs.length > 0 ? (
              jobs.map((job) => (
                <div className="tl_listst" key={job.id}>
                  <div className="titls_list">
                    <p>
                      {job.team_name} • {job.work_flexibility}
                    </p>
                    <h4>{job.title}</h4>
                    <p>{job.description}</p>
                  </div>
                  <div className="en_titlss">
                    <p>Location: {job.country_name}{job.state_name}{job.city_name}</p>
                  </div>
                </div>
              ))
            ) : (
              <p>No jobs found</p>
            )}

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="paginetionss">
                <ul>
                  {[...Array(totalPages)].map((_, index) => (
                    <li key={index}>
                      <button
                        onClick={() => setPage(index + 1)}
                        className={page === index + 1 ? "act" : ""}
                      >
                        {index + 1}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default JobOpening;
